import { Sash } from '@icc/window-door/types';
import { ProfilesService } from '@icc/construction-elements/configurator';
import { ModalService, StepsService } from '@icc/configurator/shared';
import { IssueLevel, core, isDefined, isUndefined } from '@icc/shared/helpers';
import { ConfigurationsService } from '@icc/configurator/shared';
import { ConfiguratorsDataService, APP_CONFIG, AppConfigFactory, EventBusService, TranslateService, BaseIssuesService } from '@icc/shared';
import { WindowActiveConfiguration } from '@icc/window-door/types';
import { Injectable, Inject } from '@angular/core';
import { SashTypesService } from '../layout/sash-types.service';
import { SashTypeDto } from '@icc/window-door/types';
import { SashTypesPageComponent } from '../../sash-types-page/sash-types-page.component';
import { ActiveSash } from '@icc/window-door/types';

@Injectable()
export class SashesTypesService {
    private sashTypes: SashTypeDto[] = [];
    sills = [];
    layouts = [];
    loadedData = false;

    constructor(
        private modalService: ModalService,
        private configurationsService: ConfigurationsService<'window'>,
        private configuratorsDataService: ConfiguratorsDataService,
        @Inject(APP_CONFIG) private config: AppConfigFactory,
        private eventBusService: EventBusService,
        private sashTypesService: SashTypesService,
        private stepsService: StepsService,
        private profilesService: ProfilesService,
        private issuesService: BaseIssuesService,
        private translateService: TranslateService
    ) {
        if (this.configuratorsDataService.loaded) {
            this.init();
        }

        this.eventBusService.subscribeWithoutConfiguration('initializedConfigurator', () => {
            this.init();
        });
    }

    public hideFittingStepIfFixedLayout(){
        if (this.configurationsService.conf.Current.SashesType==='FixSash' || this.configurationsService.conf.Current.SashesType==='Fix'){
            this.stepsService.disable('fitting');
        } else {
            this.stepsService.enable('fitting');
        }
    }
    /**
     * Funkcja inicjalizujaca
     */
    private init() {
        this.sashTypes = this.configuratorsDataService.data.sashTypes;
        this.loadedData = true;
    }

    /**
     * Funkcja otwierania okna modal typów skrzydeł
     */
    public openSashTypeModalOne() {
        this.openSashTypeModal(this.configurationsService.conf.Current.Sashes[0]);
    }

    /**
     * Funkcja otwierania okna modal typów skrzydeł
     * @param  {[type]} sash [description]
     * @return {[type]}      [description]
     */
    public openSashTypeModal(sash: ActiveSash) {
        // brak skrzydła, bład powodowany za szybkim klikaniem (kliknięciem w podział i kliknięciem w wybór skrzydła przed podzieleniem)
        if (isUndefined(sash) || sash === null) {
            return;
        }

        const conf = this.configurationsService.conf.Current;
        const filteredProfiles = this.profilesService.getFilteredProfiles(conf,  conf.System.door_type ? 'virtual_door_sash' : 'sash', {and: ['bottom']});

        const modalInstance = this.modalService.open({
            templateUrl: 'modalSashType.html',
            controller: 'ModalSashTypeCtrl as msashType',
            pageComponent: SashTypesPageComponent,
            resolve: {
                profiles: () => filteredProfiles,
                sashTypes: () => {
                    return this.getMatchingSashTypes(this.sashTypes, sash);
                },
                sash: () => {
                    return sash;
                },
                availableSashTypes: () => {
                    return conf.System?.available_sash_types ?? [];
                },
            },
        });

        modalInstance.closed.then(() => {});

        modalInstance.result.then(selectedSashType => {
            if (typeof selectedSashType !== 'undefined') {
                const valid = this.validateSashTypeForProfileOptions(sash,selectedSashType?.type);
                const divs = this.configurationsService.conf.Current.Mullions;
                const lDiv = divs[core.fId(divs, sash.nearMullions.left)];
                const rDiv = divs[core.fId(divs, sash.nearMullions.right)];

                const falseMullionsMap = {
                    DS: 'DK',
                    DSH: 'DK',
                    DSC: 'DK',
                    ODS: 'OD',
                    ODSH: 'OD',
                    DRP: 'DRA',
                    DOP: 'DOA',
                    S: 'S',
                    HS: 'HS',
                    PSK: 'PSK',
                };
                if (valid){
                    this.sashTypesService.setType(
                        sash,
                        selectedSashType,
                        this.configurationsService.conf.Current
                    );

                    if (falseMullionsMap[selectedSashType.type] && selectedSashType.passive) {
                        if (selectedSashType.handle_position === 'R' && rDiv.multiAlignRight[0]) {
                            const sashType = this.sashTypes.find(
                                s =>
                                    s.type === falseMullionsMap[selectedSashType.type]
                                    && s.handle_position === 'L'
                                    && !s.passive
                            );
                            if (sashType) {
                                this.sashTypesService.setType(
                                    rDiv.multiAlignRight[0],
                                    sashType,
                                    this.configurationsService.conf.Current
                                );
                            }
                        }
                        if (selectedSashType.handle_position === 'L' && lDiv.multiAlignLeft[0]) {
                            const sashType = this.sashTypes.find(
                                s =>
                                    s.type === falseMullionsMap[selectedSashType.type]
                                    && s.handle_position === 'R'
                                    && !s.passive
                            );
                            if (sashType) {
                                this.sashTypesService.setType(
                                    lDiv.multiAlignLeft[0],
                                    sashType,
                                    this.configurationsService.conf.Current
                                );
                            }
                        }
                    }
                }
                this.hideFittingStepIfFixedLayout();
                // przerysuj rysunek
                this.eventBusService.post({
                    key: 'icc-redraw',
                    value: 'frame',
                });
            }
        });
    }


    public getMatchingSashTypes(sashTypes: SashTypeDto[], sash: ActiveSash) {
        const conf = this.configurationsService.conf.Current;
        const divs = conf.Mullions;
        const shape = conf.Shape;
        const lDiv = divs[core.fId(divs, sash.nearMullions.left)];
        const rDiv = divs[core.fId(divs, sash.nearMullions.right)];

        const minWidthGlass = this.config().IccConfig.Configurators.minWidthGlass;
        const profileInner =  this.profilesService.getProfile(conf.ProfileSet['sash']);
        const profileOuter =  this.profilesService.getProfile(conf.ProfileSet['sashOutward']);

        return sashTypes.filter((type) => {
            if (!type.configurators.includes(conf.type)) {
                return false;
            }

            if (['HS', 'S'].includes(type.type) && !this.config().IccConfig.Configurators.hs.layoutEditing) {
                return false;
            }
            if (type.type === 'PSK' && !this.config().IccConfig.Configurators.selectPSK) {
                return false;
            }
            if (['DRA', 'DRP', 'DOA', 'DOP'].includes(type.type) && conf.type === 'window') {
                return false;
            }

            if (type.passive
                && type.handle_position === 'R'
                && (isUndefined(rDiv)
                    || rDiv.multiAlignRight.length !== 1
                    || rDiv.multiAlignLeft.length !== 1
                )
            ) {
                return false;
            }
            if (type.passive
                && type.handle_position === 'L'
                && (isUndefined(lDiv)
                    || lDiv.multiAlignLeft.length !== 1
                    || lDiv.multiAlignRight.length !== 1
                )
            ) {
                return false;
            }

            const doorSashTypes = ['DRA', 'DRP', 'DOA', 'DOP', 'F'];
            if (this.config().IccConfig.Configurators.fixInFixDoor) {
                doorSashTypes.push('FF');
            }
            if (conf.type === 'door' && doorSashTypes.indexOf(type.type) === -1) {
                return false;
            }

            if (conf.type === 'door' && type.type === 'F'
                && sash.nearMullions.top === -1 && sash.nearMullions.bottom === -1
                && sash.nearMullions.left === -1 && sash.nearMullions.right === -1) {
                return false;
            }

            if (conf.type === 'door' && sash.type.type === 'F' && sash.nearMullions.top === -1 && sash.nearMullions.bottom > -1) {
                return false;
            }

            let allowedTypes;
            let restrict;
            //koło - jedno skrzydło
            if (shape.shape === 'circle'
                && sash.nearMullions.top === -1 && sash.nearMullions.bottom === -1
                && sash.nearMullions.left === -1 && sash.nearMullions.right === -1) {
                allowedTypes = ['F', 'FF', 'OFF','K'];
                restrict = {
                    F  : [150, ],
                    FF : [230, ],
                    OFF: [230, ],
                    K  : [230, 600]
                };
                if (allowedTypes.indexOf(type.type) === -1) {
                    return false;
                }
                if (isDefined(restrict[type.type])
                    && ((isDefined(restrict[type.type][0]) && restrict[type.type][0] > shape.d / 2)
                    || (isDefined(restrict[type.type][1]) && restrict[type.type][1] < shape.d / 2))) {
                    return false;
                }
            }

            //koło - dwa skrzydła ||
            if (shape.shape === 'circle'
                && sash.nearMullions.top === -1 && sash.nearMullions.bottom === -1
                && (sash.nearMullions.left > -1 || sash.nearMullions.right > -1)) {
                allowedTypes = ['F', 'FF', 'OFF'];
                restrict = {
                    F  : [150, ],
                    FF : [230, ],
                    OFF: [230, ]
                };
                if (allowedTypes.indexOf(type.type) === -1) {
                    return false;
                }
                if (isDefined(restrict[type.type])
                    && ((isDefined(restrict[type.type][0]) && restrict[type.type][0] > shape.d / 2)
                    || (isDefined(restrict[type.type][1]) && restrict[type.type][1] < shape.d / 2))) {
                    return false;
                }
            }

            //koło - dwa skrzydła = - skrzydło górne
            if (shape.shape === 'circle'
                && sash.nearMullions.left === -1 && sash.nearMullions.right === -1
                && sash.nearMullions.top === -1 && sash.nearMullions.bottom > -1) {
                allowedTypes = ['F', 'FF', 'OFF', 'K'];
                restrict = {
                    F  : [150, ],
                    FF : [230, ],
                    OFF: [230, ],
                    K  : [230, ]
                };
                if (allowedTypes.indexOf(type.type) === -1) {
                    return false;
                }
                if (isDefined(restrict[type.type])
                    && ((isDefined(restrict[type.type][0]) && restrict[type.type][0] > shape.d / 2)
                    || (isDefined(restrict[type.type][1]) && restrict[type.type][1] < shape.d / 2))) {
                    return false;
                }
            }

            //koło - dwa skrzydła = - skrzydło dolne
            if (shape.shape === 'circle'
                && sash.nearMullions.left === -1 && sash.nearMullions.right === -1
                && sash.nearMullions.bottom === -1 && sash.nearMullions.top > -1) {
                allowedTypes = ['F', 'FF', 'OFF'];
                restrict = {
                    F  : [150, ],
                    FF : [230, ],
                    OFF: [230, ]
                };
                if (allowedTypes.indexOf(type.type) === -1) {
                    return false;
                }
                if (isDefined(restrict[type.type])
                    && ((isDefined(restrict[type.type][0]) && restrict[type.type][0] > shape.d / 2)
                    || (isDefined(restrict[type.type][1]) && restrict[type.type][1] < shape.d / 2))) {
                    return false;
                }
            }

            if (['PSK', 'SU', 'SD', 'HS', 'S'].indexOf(type.type) > -1 && sash.shape.shape !== 'rect') {
                return false;
            }

            if (
                this.config().IccConfig.Configurators.noHingesOnSlope &&
                ['F', 'FF', 'OFF'].indexOf(type.type) === -1 &&
                ((type.handle_position === 'R' && sash.shape.angles.hasLeftSlopeSide) ||
                    (type.handle_position === 'L' && sash.shape.angles.hasRightSlopeSide))
            ) {
                return false;
            }

            if (conf.drawData && type.type !== 'F') {
                const minWidthSash = this.determineMinSashHeight(conf, sash, minWidthGlass);
                if (minWidthSash !== null) {
                    if (profileInner && !type.out_open && sash.rWidth < minWidthSash + profileInner.width * 2) {
                        return false;
                    }

                    if (profileOuter && type.out_open && sash.rWidth < minWidthSash + profileOuter.width * 2) {
                        return false;
                    }
                }
            }
            return true;
        }).filter(type=>{
            if (type?.configurators && type?.configurators.length > 0 && this.config().IccConfig.Configurators.filterSashTypeByConfigurator){
                return type.configurators.indexOf(conf.type) > -1;
            } else {
                return true
            }
        });
    }

    private determineMinSashHeight(conf: WindowActiveConfiguration, sash: ActiveSash | Sash, minWidthGlass: number) {
        if (!conf.drawData) {
            return null;
        }
        const glazingBeadData = conf.drawData.glazingBead.find(gb => gb.sashId === sash.id);
        const glazingData = conf.drawData.filling.find(gb => gb.sashId === sash.id);
        const sashData = conf.drawData.sash.find(s => s.sashId === sash.id);
        if (!glazingBeadData || !sashData || !glazingData) {
            return null;
        }
        const rect = glazingBeadData?.inner?.rect?.x && isFinite(glazingBeadData?.inner?.rect?.x) ? glazingBeadData.inner.rect : glazingData?.rect;
        return rect.y - sashData.outer.rect.y + minWidthGlass + (sashData.outer.rect.y + sashData.outer.rect.height) - (rect.y + rect.height)
    }

    canBeSashTypeChanged(conf: WindowActiveConfiguration, sash: Sash) {
        const availableSashTypes = conf.System.available_sash_types;
        const minWidthGlass = this.config().IccConfig.Configurators.minWidthGlass;

        const canBeInner =
            availableSashTypes && availableSashTypes.length
                ? availableSashTypes.some(t =>
                      this.sashTypes.some(st => st.id === t && !st.out_open)
                  )
                : true;
        const canBeOuter =
            availableSashTypes && availableSashTypes.length
                ? availableSashTypes.some(t =>
                      this.sashTypes.some(st => st.id === t && st.out_open)
                  )
                : true;

        if (conf.drawData) {
            const profileInner = this.profilesService.getProfile(conf.ProfileSet['sash']);
            const profileOuter = this.profilesService.getProfile(conf.ProfileSet['sashOutward']);
            const minWidthSash = this.determineMinSashHeight(conf, sash, minWidthGlass);
            if (minWidthSash !== null && (profileInner || profileOuter)) {
                if ((!profileInner || profileInner && canBeInner && sash.width < minWidthSash + profileInner.width * 2)
                    && (!profileOuter || profileOuter && canBeOuter && sash.width < minWidthSash + profileOuter.width * 2)) {
                    return false;
                }
            }
        }
        return true;
    }

    private getSashTypeCode(sashType: any): string | null {
        if (typeof sashType === 'string') {
            return sashType;
        }

        if (sashType && typeof sashType === 'object') {
            if (typeof sashType.type === 'string') {
                return sashType.type;
            }

            if (typeof sashType.code === 'string') {
                return sashType.code;
            }
        }

        return null;
    }

    isSashTypeValid(profileId,sashType){
        const frameProfile = this.profilesService.getProfile(profileId);
        const forGlazing = frameProfile?.options?.includes('for_glazing');
        const forHardware = frameProfile?.options?.includes('for_hardware');
        const isFix = ['F', 'OFF'].includes(sashType);
        const valid = forGlazing === forHardware || (forGlazing && isFix) || (forHardware && !isFix);
        return {
            valid: valid,
            invalidBecauseFix: forHardware,
            invalidBecauseNoFix: forGlazing
        }
    }

    validateSashTypeForProfileOptions(sash, selectedSashType, conf = this.configurationsService.conf.Current, frameId?){
        const id = sash?.frameId ?? frameId;
        let currentFrame = conf.Frames.find(f => f.id === id) || conf.Frames[id];
        if (currentFrame) {
            const selectedSashTypeCode = this.getSashTypeCode(selectedSashType);
            const hasSashId = Number.isFinite(Number(sash?.id));

            if (hasSashId && selectedSashTypeCode) {
                this.profilesService.setPlannedSashTypeForValidation(Number(sash.id), selectedSashTypeCode);
            }

            try {
            let invalidBecauseFix = false;
            let invalidBecauseNoFix = false;
            let isValid = Object.entries(currentFrame.frame).every(([side, frameObj]) => {
                const data = this.isSashTypeValid(frameObj?.alt?.profileId ?? frameObj.profileId,selectedSashType);
                invalidBecauseFix = invalidBecauseFix || !!data?.invalidBecauseFix;
                invalidBecauseNoFix = invalidBecauseNoFix || !!data?.invalidBecauseNoFix;
                return data.valid;
            });
            if (!isValid){
                const avaliableProfiles = this.profilesService.getAvailableProfilesForSashType(invalidBecauseFix,invalidBecauseNoFix,conf)
                if (avaliableProfiles?.length > 0){
                    const sashesInFrameTypes = conf.Sashes
                        .filter(s => s?.frameId === currentFrame?.id)
                        .map(s => s?.type?.type);
                    const sashInFrameIndex = conf.Sashes.findIndex(
                        s => s?.id === sash?.id && s?.frameId === currentFrame?.id
                    );
                    if (sashInFrameIndex > -1) {
                        sashesInFrameTypes[sashInFrameIndex] = selectedSashType;
                    }

                    const validCandidateProfile = this.profilesService.autoSelectFrameProfileForSashTypes(
                        conf,
                        currentFrame,
                        sashesInFrameTypes,
                        true
                    );

                    if (validCandidateProfile) {
                        isValid = true;
                        this.issuesService.unregister('sash-type-invalid', conf);
                    }
                }
                if (!isValid && invalidBecauseNoFix && !invalidBecauseFix){
                    this.issuesService.simpleRegister(
                        'sash-type-invalid',
                        'Niepoprawne profile ramy',
                        this.translateService.instant('WINDOW|Dostępne profile ramy tylko dla szklenia'),
                        conf,
                        {
                            level: IssueLevel.ERROR,
                            logLevel: IssueLevel.WARN,
                            blockStepsAfter: null,
                        }
                    );
                } else if (!isValid && invalidBecauseFix && !invalidBecauseNoFix) {
                    this.issuesService.simpleRegister(
                        'sash-type-invalid',
                        'Niepoprawne profile ramy',
                        this.translateService.instant('WINDOW|Brak dostępnego profilu dla szklenia i dla okuwania'),
                        conf,
                        {
                            level: IssueLevel.ERROR,
                            logLevel: IssueLevel.WARN,
                            blockStepsAfter: null,
                        }
                    );
                } else if (!isValid) {
                    this.issuesService.simpleRegister(
                        'sash-type-invalid',
                        'Niepoprawne profile ramy',
                        this.translateService.instant('WINDOW|Nie można zastosować wybranego typu skrzydła dla aktualnych profili ramy'),
                        conf,
                        {
                            level: IssueLevel.ERROR,
                            logLevel: IssueLevel.WARN,
                            blockStepsAfter: null,
                        }
                    );
                }
            } else {
                const allValid = this.validateAllSashTypesInFrame(currentFrame,{type: selectedSashType, id: sash?.id});
                if (allValid){
                    this.issuesService.unregister('sash-type-invalid', conf);
                }
            }
            return isValid;
            } finally {
                if (hasSashId && selectedSashTypeCode) {
                    this.profilesService.setPlannedSashTypeForValidation(Number(sash.id), null);
                }
            }
         }
    }

    validateAllSashTypesInFrame(frame, newSash?, sashTypes?, conf = this.configurationsService.conf.Current) {
        const sashes = sashTypes || conf.Sashes.filter(i=>i?.frameId === frame?.id).map(sash=>sash?.type?.type);
        if (newSash){
            const sashInFrameIndex = conf.Sashes.findIndex(s => s?.id === newSash?.id && s?.frameId === frame?.id);
            if (sashInFrameIndex > -1) {
                sashes[sashInFrameIndex] = newSash?.type;
            }
        }
        return !frame || frame.frame.every(frameObj => {
            return sashes.every(sashType => this.isSashTypeValid(frameObj?.alt?.profileId ?? frameObj?.profileId, sashType)?.valid)
        });
    }

}
